import React from "react"

const PurchasesIconActive = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
            <path d="M7 15L14.2632 15C18.7508 15 19.4333 12.1808 20.261 8.06908C20.4998 6.88311 20.6192 6.29013 20.3321 5.89507C20.045 5.5 19.4947 5.5 18.3941 5.5H18M5 5.5H6.5" stroke="#21A6AA" stroke-width="1.5" stroke-linecap="round" />
            <path d="M9.5 6C9.5 6 10.5 6 11.5 8C11.5 8 14.6765 3 17.5 2" stroke="#21A6AA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M7 15L4.37873 2.51493C4.15615 1.62459 3.35618 1 2.43845 1L1.5 1" stroke="#21A6AA" stroke-width="1.5" stroke-linecap="round" />
            <path d="M7.88 15H7.46857C6.10522 15 5 16.1513 5 17.5714C5 17.8081 5.1842 18 5.41143 18L16.5 18" stroke="#21A6AA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <circle cx="9.5" cy="19.5" r="1.5" stroke="#21A6AA" stroke-width="1.5" />
            <circle cx="16.5" cy="19.5" r="1.5" stroke="#21A6AA" stroke-width="1.5" />
        </svg>
    )
}
export default PurchasesIconActive